<script setup lang="ts">
import { Editor } from "@tiptap/vue-3";
import ParagraphIndentIcon from "@/components/icon/ParagraphIndentIcon.vue";

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    editor: Editor;
  }>(),
  {
    disabled: false,
  }
);

const onClick = () => {
  props.editor.chain().focus().toggleIndent().run();
};
</script>
<template>
  <button
    class="btn btn-sm btn-ghost rounded"
    @click="onClick"
    :disabled="disabled"
    :class="{
      'bg-primary': editor.isActive('paragraph', { indent: true }),
    }"
  >
    <paragraph-indent-icon class="icon-sm" />
  </button>
</template>
